export const SupportedCountries = ['ca', 'us']
